import React from 'react';
import Dropzone from 'react-dropzone-uploader'
import * as XLSX from 'xlsx';
import { connect } from 'react-redux';
import history from '../../history';
import SubHeader from './SubHeader';
import api from "../../api/api";
import uri from "../../variables/uri";
import { setLoading } from '../../actions/authAction';
import AlertModal from '../modals/AlertModal';

class UploadEmployee extends React.Component {
    state = {
        isOpenMessage: false,
        type:1,
        message: "",
        text: "",
    };
    // called every time a file's `status` changes
    handleChangeStatus = ({ meta, file }, status) => { console.log(status, meta, file) }

    // receives array of files that are done uploading when submit button is clicked
    handleSubmit = (files, allFiles) => {
        if (!this.props.isAuthen || (!this.props.auth.isAdmin)) {
            history.push(`/home/${localStorage.getItem('username')}`)
        } 
        this.props.setLoading(true);
        var file = allFiles[0].file;
        var reader = new FileReader();
        reader.readAsBinaryString(file, "UTF-8")
        reader.onload = async () => {
            var data = reader.result;
            let readedData = XLSX.read(data, { type: 'binary' });
            const wsname = readedData.SheetNames[0];
            const ws = readedData.Sheets[wsname];

            const dataParse = XLSX.utils.sheet_to_json(ws, { header: 1 });
            const excelArr = dataParse.filter((item, i) => item.length > 0 && i !== 0);

            const arrObj = [];
            excelArr.forEach(element => {
                arrObj.push({
                    personnelNumber: element[0],
                    companyCode: element[1],
                    userId: element[2],
                    employeeName: element[3],
                    departmentCode: element[4],
                    departmentName: element[5],
                    employeeLevel: element[6],
                    validDateFrom: element[7],
                    validDateTo: element[8]
                });
            });

            console.log(arrObj);
            const response = await api.post('Upload/UploadEmployee', {
                EmployeeList: arrObj
            });

            if(response.status === 200) {
                //this.props.setAlert({ isAlert: true, title: 'Uploaded Successfully'})
                this.setState({isOpenMessage: true, message:'Uploaded Successfully.', type:1})
            }
            this.props.setLoading(false);
        };

        console.log(files.map(f => f.meta));
        allFiles.forEach(f => f.remove());
    }

    onClose = () =>{
        this.setState({isOpenMessage: false});
    }
    
    render() {
        return (
            <div className="flex-v home">
            <SubHeader text={`Upload Employee level`} />
                <div className="card">
                    <div className="card-content p-24">
                        <Dropzone
                            onChangeStatus={this.handleChangeStatus}
                            onSubmit={this.handleSubmit}
                            accept=".csv,.xls,.xlsx"
                            maxFiles={1}
                            multiple={false}
                            inputContent="Drag File or Click to Browse"
                        />
                    </div>
                </div>
                <AlertModal isOpen={this.state.isOpenMessage} message={this.state.message} onClose={this.onClose} type={this.state.type} />
            </div>
        );
    }
}
const mapStateToProps = (state) => {
    return {
        bookList: state.doa.bookList,
        permissionList: state.doa.permissionList,
        isAuthen: state.auth.isAuthen,
        auth: state.auth,
    }
}
export default connect(mapStateToProps, {
    setLoading
})(UploadEmployee)